import { DataType } from './../../enums/datatype.enum';
import { Align } from './../../enums/align.enum';
import { Metadata } from './metadata.component';

export class DefaultMetadata {
    static getMetadata(exibirStatus?: boolean): Metadata[] {
      if ( exibirStatus === undefined ) {
        exibirStatus = true;
      }

      return [
        {
            fieldId: 'id',
            fieldName: 'Id',
            align: Align.RIGHT,
            dataType: DataType.NUMBER
        },
        {
            fieldId: 'status',
            fieldName: 'Status',
            align: Align.CENTER,
            dataType: DataType.HTML,
            fnValorCelula: (data: any) => {
              if ( data && data.status === 'A' ) {
                return 'Ativo';
              }
              else if ( data && data.status === 'I' ) {
                return `<label class='danger'>Inativo</label>`;
              }

              return '';
            },
            hidden: !exibirStatus
        }
    ];
    }
}
